export default "__VITE_ASSET__CT6bJtub__"